import { nextTick, reactive } from 'vue';
import PlanningElement from '@/models/PlanningElement';
import useUiPlanningStore from '@/stores/ui/planning';
import useUsersStore from '@/stores/users';
import useUsersAccessRightStore from '@/stores/users/accessRight';
import usePlanningStore from '../planning';
import usePlanningElementsStore from '../elements';

/** ********** */
/*  MUTATIONS  */
/** ********** */
export function commitAdd(newel) {
  const { planning } = usePlanningStore();
  planning.elements.push(newel);
}

export function commitRemove(el) {
  const { planning } = usePlanningStore();
  const index = planning.elements.indexOf(el);
  if (index > -1) planning.elements.splice(index, 1);
  // remove from selection for undo redo
}

export function commitEmpty() {
  const { planning } = usePlanningStore();
  planning.elements.splice(0, planning.elements.length);
}

/** ******** */
/*  ACTIONS  */
/** ******** */
/** ******* ADD ******** */
export function insertNewElement(newel) {
  const { planning } = usePlanningStore();
  const el = reactive(new PlanningElement(planning, newel));
  commitAdd(el);
  el.update();
  nextTick(() => el.updateHeight());
  return el;
}

export function addElementHelper({ type = 'task', lane, el, positionLeft, y }) {
  if (! lane) return false;

  const { planning } = usePlanningStore();
  const id = usePlanningElementsStore().nextId;

  let newel;
  if (el) {
    newel = insertNewElement(el.getAll());
    newel.setDependencies(null);
    newel.id = id;
  } else {
    newel = insertNewElement({ type });
    newel.id = id;
    const width = type == 'milestone' ? 70 : 130;
    const isKanbanMode = useUiPlanningStore().mode == 'kanban';
    if (isKanbanMode) {
      newel.kanbanMove(lane.id, positionLeft + width / 2, y);
      newel.setWidth(width);
    } else {
      newel.setLaneId(lane.id);
      const starttime = moment(planning.visibleTimeline.starttime)
        .addWithWorkdays(0.2 * moment.duration(1, planning.timeline.steps[0]).as('minutes'), 'minutes', planning.timeline.workdays);
      newel.setStartTime(starttime);
      newel.setEndTime(starttime);
      newel.setWidth(0);
      newel.resize(width, null);
    }
  }

  const usersAccessRightStore = useUsersAccessRightStore();
  if (usersAccessRightStore.config.assignBubblesToCreator && newel.isType('task')) {
    const { user } = useUsersStore();
    const newelUsers = (newel.getUsers() || []).filter(item => item.id != user.id);
    const fields = ['id', 'email', 'firstname', 'lastname', 'avatar'];
    newelUsers.unshift({ ..._.pick(user, fields) });
    newel.setUsers(newelUsers);
  }

  if (typeof positionLeft !== 'undefined') {
    newel.move(lane.id, positionLeft);
  }

  newel.update();
  return newel;
}
